<template>
    <div>
        <div class="center fs18" style="padding-top: 10px;">
            <p class="black fs32 fw500">{{ $t('search') }}</p>
            <span class="backyel dib divide"></span>
        </div>
        <div class="s1">
            <div class="center" :class="$style.wrappervideo">
                <video v-if="video" 
					muted autoplay loop
					:src="video"
					controls="controls"
					 preload="auto"
					 webkit-playsinline="true"
					 playsinline="true"
					 x5-video-player-type="h5"
					 x5-video-player-fullscreen="true"
					 x-webkit-airplay="allow" 
					 x5-video-orientation="portraint"
					:class="$style.video"></video>
            </div>
            <p class="center fs24 backblack white fw500" style="line-height: 3.4;">{{ $t('search1') }}</p>
            <div class="backgray dflex showInLargef" style="padding: 60px;">
                <card v-if="availiableList[2*availiablePage]" :item="availiableList[2*availiablePage]" style="width:50%;"></card>
                <card v-if="availiablePage+1 < availiableList.length && availiableList[2*availiablePage+1]" :item="availiableList[2*availiablePage+1]" style="width:50%;"></card>
            </div>
            <div class="right white showInLargeb" style="font-size:32px;">
                <span :class="$style.btn" :disabled="!acanPre" class="backyel" @click="acanPre && availiablePage--">&lt;</span>
                <span :class="$style.btn" :disabled="!acanNext" class="backyel" @click="acanNext && availiablePage++">&gt;</span>
            </div>
            <div class="backwg dflex showInSmall">
                <card :class="$style.back" v-if="availiableList[savailiablePage]" :item="availiableList[savailiablePage]" style="width:100%;padding: 5%;"></card>
                <div class="center white backwg" style="padding-bottom: 20px;">
                    <span :class="$style.btn" :disabled="!sacanPre" class="backyel" @click="sacanPre && savailiablePage--">&lt;</span>
                    <span :class="$style.btn" :disabled="!sacanNext" class="backyel" @click="sacanNext && savailiablePage++">&gt;</span>
                </div>
            </div>
        </div>
        <div :class="$style.sbody">
            <img src="../assets/filter.svg" width="28" style="vertical-align: -6px;">
            <span class="cp fs26 yel" @click="showFilter = !showFilter" style="margin-left: 20px;">{{ $t('filter') }}</span>
            <p class="fs18 gray dib" style="margin-left: 20px;">
                <el-input
                    :placeholder="$t('sc')"
                    prefix-icon="el-icon-search"
                    size="small"
                    :clearable="true"
                    v-model="searchCode"
                    @change="codeSearch">
                </el-input>
            </p>
            <div v-if="showFilter" class="backgray showInLargeb" style="padding: 30px;margin-top: 20px;">
                <p class="gray fs20" style="margin-bottom:10px;">{{$t('filterMessage')}}</p>
                <div class="dflex fs26">
                    <div v-for="item in filterData" :key="item.key" class="f1 dflex fc">
                        <p>{{ item.label }}</p>
                        <el-checkbox-group v-model="filter[item.key]" size="medium">
                            <el-checkbox v-for="op in item.options" :key="op.key" :label="op.key" :class="item.key === 'zodiac' ? $style['search2'] : $style['search1']">{{ op.label }}</el-checkbox>
                        </el-checkbox-group>
                        <div v-if="item.key === 'age'" class="f1 dflex fc">
                            <div class="f1"></div>
                            <p style="padding-left: 64px;padding-bottom:20px;">
                                <el-link type="primary" @click="resetSearch">{{$t('reset')}}</el-link>
                            </p>
                            <p>
                                <ubutton :text="$t('search')" @click="refreshList"></ubutton>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="showFilter" class="backgray showInSmallb dflex" style="padding: 30px;margin-top: 20px; with: 100%;">
            <p class="gray fs20" style="margin-bottom:10px;">{{$t('filterMessage')}}</p>
            <div class="dflex fs26 mb30 fw" style="with: 100%;">
                <div v-for="item in filterData" :key="item.key" style="width: 50%;margin-bottom: 10px;">
                    <p>{{ item.label }}</p>
                    <el-checkbox-group v-model="filter[item.key]" size="medium">
                        <el-checkbox v-for="op in item.options" :key="op.key" :label="op.key" :class="item.key === 'zodiac' ? $style['search2'] : $style['search1']">{{ op.label }}</el-checkbox>
                    </el-checkbox-group>
                </div>
            </div>
            <div class="center">
                <p style="padding-bottom:10px;">
                    <el-link type="primary" @click="resetSearch">{{$t('reset')}}</el-link>
                </p>
                <ubutton :text="$t('search')" @click="refreshList"></ubutton>
            </div>
        </div>
        <div v-loading="isLoading" :class="$style.sbody">
            <div class="dflex fw" style="justify-content: space-between;">
                <card v-for="item in list" 
				:showDialogFunc="showDialog" 
				:key="item.code" :item="item" 
				@setYoutubeVideoId="setVideoId"
				:class="$style.item"></card>
            </div>
            <div class="center" v-if="showPagination">
                <el-pagination
                    layout="prev, pager, next"
                    @current-change="onCurrentChange"
                    :current-page.sync="page"
                    :hide-on-single-page="true"
                    :page-count="totalPage">
                </el-pagination>
            </div>
			<reminderDialogVue :close="closeDialog" :p="reminderMsg" :requiredDialogVisible.sync = "requiredDialogVisible"></reminderDialogVue>
			<playVideoDialogVue 
				v-show="videoId != ''" 
				:dialogVisible="playVideoVisible" 
				@closePlayDialog="handleCancleYoutubePlay"
				:videoId="videoId"></playVideoDialogVue>
        </div>
    </div>
</template>
<script>
import reminderDialogVue from '../components/reminderDialog.vue';
import playVideoDialogVue from '../components/playVideoDialog.vue';

export default {
    name: 'Search',
	components: {
		reminderDialogVue,
		playVideoDialogVue,
	},
    data() {
        return {
            availiableList: [],
            availiablePage: 0,
            savailiablePage: 0,
            showFilter: false,
            filterData: [
                {key: 'first_need', label: this.$t('fneed'), options: []},

                {key: 'second_need', label: this.$t('sneed'), options: []},

                {key: 'zodiac', label: this.$t('zodiac'), options: []},

                {key: 'age', label: this.$t('age'), options: []},
            ],
            filter: {
                first_need: [],
                second_need: [],
                zodiac: [],
                age: [],
            },
            page: +localStorage.getItem('selectPage') || (+localStorage.getItem('page') || 1),
            totalPage: 1,
            showPagination: false,
            isLoading: true,
            list: [],
            searchCode: '',
            video: '',
			reminderMsg: [
				this.$t('reminderp1'),
				this.$t('reminderp2'),
			],
			requiredDialogVisible: false,
			playVideoVisible:false,
			videoId: '',
        };
    },
    computed: {
        acanNext() {
            return (this.availiablePage + 1) * 2 < this.availiableList.length;
        },
        acanPre() {
            return this.availiablePage > 0;
        },
        sacanNext() {
            return (this.savailiablePage + 1) < this.availiableList.length;
        },
        sacanPre() {
            return this.savailiablePage > 0;
        },
    },
    watch: {
        page(value, pre) {
            localStorage.setItem('page', value);
        },
        'filter.zodiac'(value, pre) {
            // 选择所有
            if (value.length > 0 && value[value.length - 1] === 'All') {
                const zodiacData = this.filterData.find((item) => item.key === 'zodiac');
                this.filter.zodiac = zodiacData.options.map((item) => item.key);
            } else if (value.length > 0) {
                // 去掉选择所有
                if (pre.includes('All') && !value.includes('All')) {
                    this.filter.zodiac = [];
                }
            }
        }
    },
    created() {
        this.getVideo();
        this.getSearchText();
        this.getTodayAvailiableList();
        this.loadlist();
        this.$top();
    },
    methods: {
		handleCancleYoutubePlay(){
			this.playVideoVisible = false;
			this.videoId = "";
		},
		setVideoId(videoId){
			this.playVideoVisible = true;
			this.videoId = videoId;
		},
		showDialog() {
			this.requiredDialogVisible = true;
		},
		closeDialog() {
			this.requiredDialogVisible = false;
		},
        getVideo() {
            this.$service.getVideo().then(res => {
                this.video = res.data.video[this.$i18n.locale];
            });
        },
        getSearchText() {
            this.$service.getSearchText()
                .then((res) => {
                    if (res.data) {
                        for (var i = 0; i < res.data.length; ++i) {
                            var cur = res.data[i];
                            if (cur[this.$i18n.locale]) {
                                cur = cur[this.$i18n.locale];
                            }
                            var keys = Object.keys(cur);
                            for (var j = 0; j < keys.length; ++j) {
                                this.filterData[i].options.push({
                                    key: keys[j],
                                    label: cur[keys[j]],
                                })
                            }
                        }
                    }
                });
        },
        codeSearch(value) {
            this.searchCode = value;
            this.refreshList();
        },
        getTodayAvailiableList() {
            this.$service.getTodayAvailiableList()
                .then((response) => {
                    this.availiableList = response;
                    // this.availiableList = [{"code":"89759","name":"RUSHANA BBC","age":56,"birthday":"2012-04-19","zodiac":"dragon","marriage":"single","kids":"0","first_love":"Cooking","second_love":"Cleaning","third_love":null,"religion":null,"available_status":1,"head_portrait":"https:\/\/www.goldenwin.com.hk\/upload\/admin\/image\/member\/b78b0e3d6f23b022c598d4661a5eaa7c.jpg","is_favorite":0},{"code":"89760","name":"Samantha Testing","age":22,"birthday":"2012-04-19","zodiac":"dragon","marriage":"single","kids":"1","first_love":"Cooking","second_love":"Cleaning","third_love":"elderly","religion":"Catholic","available_status":1,"head_portrait":"https:\/\/www.goldenwin.com.hk\/upload\/admin\/image\/member\/ab64a37c3724d44520cc9debb4eb5468.jpg","is_favorite":0},{"code":"89761","name":"JIM MICAK","age":56,"birthday":"2012-04-19","zodiac":"dragon","marriage":"single","kids":"0","first_love":"Cooking","second_love":"Cleaning","third_love":null,"religion":null,"available_status":0,"head_portrait":"https:\/\/www.goldenwin.com.hk\/upload\/admin\/image\/member\/092c4bce37cb787fcd20e9f75d975b66.jpg","is_favorite":0}];
                });
        },
        // 從頭搜索
        refreshList() {
            this.page = 1;
            this.loadlist();
        },
        loadlist() {
            this.isLoading = true;
            const params = {
                page: ''+this.page,
            };
            var keys = Object.keys(this.filter);
            for (var i = 0; i < keys.length; ++i) {
                if (this.filter[keys[i]].length > 0) {
                    if (keys[i] === 'zodiac' && this.filter[keys[i]].includes('All')) {
                        params[keys[i]] = [];
                    }
                    else {
                        params[keys[i]] = this.filter[keys[i]].join(',');
                    }
                }
            }
            if (this.searchCode) {
                params.code = this.searchCode;
            }
            this.$service.getList(params).then((res) => {
                this.list = res.data.member;
                this.totalPage = res.data.page_num;
                this.showPagination = true;
                this.isLoading = false;
            });
        },
        onCurrentChange(e) {
			localStorage.setItem('selectPage', this.page);
            this.loadlist();
        },
        resetSearch() {
            var keys = Object.keys(this.filter);
            for (var i = 0; i < keys.length; ++i) {
                this.filter[keys[i]] = [];
            }
            this.refreshList();
        }
    }
}
</script>
<style module>
.btn {
    padding: 0px 23px;
    line-height: 2;
    cursor: pointer;
    display: inline-block;
}
.btn:hover {
    background: #ffd250e6;
}
.btn[disabled], .btn[disabled]:hover {
    background: #aaaaaa70;
    color: #222a33;
    cursor: not-allowed;
}
.search1 {
    display: block !important;
    margin-top: 20px;
}
.search2 {
    display: inline-block !important;
    margin-top:20px;
    width: 40%;
}
.search3 {
    display: inline-block !important;
    margin-top:20px;
    width: 23%;
}
.sbody {
    margin: 0 140px 20px 140px;
}
.item {
    margin-bottom: 60px;
    width:50%;
}
.video {
    width: 70%;
}
.wrappervideo {
    margin-top: -20px;
    padding-bottom: 60px;
}
@media screen and (max-width: 770px) {
    .sbody {
        margin: 20px 10px;
    }
    .item {
        width: 100%;
        margin-bottom: 20px;
    }
    .back {
        background-color: #aaaaaa1a;
    }
    .video {
        width: 100%;
    }
    .wrappervideo {
        margin-top: 0px;
        /* padding-bottom: 10px; */
		padding: 0px 5px 10px;
    }
}
</style>
